import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { SkipForward } from 'lucide-react';
import { gameData } from '../data/mock';

const IntroVideo = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate('/instructions');
  };

  const handleSkip = () => {
    navigate('/instructions');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-gray-900 to-zinc-900 flex flex-col items-center justify-center p-6">
      <div className="max-w-5xl w-full">
        {/* Title */}
        <div className="text-center mb-8">
          <h2 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-orange-500 mb-3">
            {gameData.introVideo.title}
          </h2>
          <p className="text-gray-300 text-lg">
            {gameData.introVideo.description}
          </p>
        </div>

        {/* YouTube Video */}
        <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-red-500/30 mb-8">
          <div className="aspect-video">
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/UinsNBOTNyU"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button
            onClick={handleContinue}
            size="lg"
            className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-bold px-8 py-6 text-xl rounded-xl transform hover:scale-105 transition-all duration-300"
          >
            Continue to Mission Brief
          </Button>
          
          <Button
            onClick={handleSkip}
            variant="outline"
            size="lg"
            className="bg-black/40 hover:bg-black/60 text-gray-300 border-gray-500 px-8 py-6 text-lg rounded-xl transition-all duration-300"
          >
            <SkipForward className="w-5 h-5 mr-2" />
            Skip Intro
          </Button>
        </div>
      </div>
    </div>
  );
};

export default IntroVideo;
